import { SITE_ORIGIN } from './homepageContent';

const LEGACY_HOSTS = new Set([
  'apdoneright.com', 'apnorthstar.com', 'www.apnorthstar.com',
  'apbiocracked.com', 'www.apbiocracked.com', 'www.ap-biology.vercel.app',
]);

export function getDomainMigrationRedirect({ hostname, pathname = '/', search = '', hash = '' }) {
  if (!LEGACY_HOSTS.has(hostname)) return null;
  // Retire the old search landing page instead of carrying its paywall funnel
  // onto the new domain. Other deep links still retain their destinations.
  const targetPath = /^\/free-trial(?:\/|$)/.test(pathname) ? '/' : pathname;
  return `${SITE_ORIGIN}${targetPath}${search}${hash}`;
}
